class CustomAddToCart {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener("click", (event) => {
      const button = event.target.closest(".add-to-cart-btn");
      if (button) {
        event.preventDefault();
        const variantId = button.dataset.variantId;
        if (variantId) this.addToCart(variantId, button);
      }
    });
  }

  async addToCart(variantId, button = null) {
    try {
      if (button) {
        button.setAttribute("aria-disabled", "true");
        button.classList.add("loading");
      }

      // Step 1: Add product to cart
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!addResponse.ok) throw new Error("Failed to add item");

      // Step 2: Get updated cart data
      const cart = await fetch("/cart.js").then((res) => res.json());

      // Step 3: Update the cart count bubble
      this.updateCartCount(cart.item_count);

      // Step 4: Refresh cart drawer
      const sectionResponse = await fetch("/?sections=cart-drawer");
      const sectionHTML = await sectionResponse.json();
      const cartDrawer = document.querySelector("cart-drawer");

      if (sectionHTML["cart-drawer"] && cartDrawer) {
        cartDrawer.outerHTML = sectionHTML["cart-drawer"];
      }

      // Step 5: Open drawer
      setTimeout(() => {
        const drawer = document.querySelector("cart-drawer");
        if (drawer && typeof drawer.open === "function") drawer.open();
      }, 300);
    } catch (error) {
      console.error("Add to cart error:", error);
    } finally {
      if (button) {
        button.removeAttribute("aria-disabled");
        button.classList.remove("loading");
      }
    }
  }

  updateCartCount(count) {
    const bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble");
    if (!bubble) return;

    const visible = bubble.querySelector("span[aria-hidden='true']");
    const hidden = bubble.querySelector(".visually-hidden");

    if (count > 0 && count < 100) {
      bubble.style.display = "block";
      visible.textContent = count;
      hidden.textContent = `${count} items in your cart`;
    } else if (count >= 100) {
      bubble.style.display = "block";
      visible.textContent = "99+";
      hidden.textContent = `${count} items in your cart`;
    } else {
      bubble.style.display = "none";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => new CustomAddToCart());
